import MDBox from "components/MDBox";
import MeasurementsSidebarBody from "./MeasurementsSidebarBody";
import MeasurementsSidebarHeader from "./MeasurementsSidebarHeader";
import SidebarFooter from "./SidebarFooter";
import SidebarToggleTab from "./SidebarToggleTab";
import { GroupedAssignment, ProductOption } from "../measurementTypes";
import { StageMeasurementDraft } from "../stageMeasurements";

const sidebarSx = {
  position: "absolute",
  top: 24,
  right: 24,
  bottom: 24,
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 20px 60px rgba(0,0,0,0.24)",
  display: "flex",
  flexDirection: "column",
  zIndex: 1500,
  overflow: "hidden",
  transition: "width 180ms ease",
} as const;

type MeasurementsSidebarProps = {
  isOpen: boolean;
  onToggle: () => void;
  measurements: StageMeasurementDraft[];
  selectedFeatureId: string | null;
  onSelectFeature: (featureId: string) => void;
  products: ProductOption[] | null;
  groupedAssignments: GroupedAssignment[];
  onUpdateProduct: (featureId: string, product: ProductOption | null) => void;
  onToggleScreenshot: (featureId: string, checked: boolean) => void;
  onSave: () => void;
  onApply: () => void;
  persisting: boolean;
  isDirty?: boolean;
  applyLoading: boolean;
  productsLoading: boolean;
  applyError: string | null;
  canSave: boolean;
  hideApply?: boolean;
  onCreateProposal?: () => void;
};

export default function MeasurementsSidebar({
  isOpen,
  onToggle,
  measurements,
  selectedFeatureId,
  onSelectFeature,
  products,
  groupedAssignments,
  onUpdateProduct,
  onToggleScreenshot,
  onSave,
  onApply,
  persisting,
  isDirty,
  applyLoading,
  productsLoading,
  applyError,
  canSave,
  hideApply,
  onCreateProposal,
}: MeasurementsSidebarProps) {
  return (
    <MDBox sx={{ ...sidebarSx, width: isOpen ? 420 : 52 }}>
      <MDBox display="flex" sx={{ flex: 1, minHeight: 0 }}>
        {isOpen && (
          <MDBox sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
            <MeasurementsSidebarHeader onHide={onToggle} />
            <MeasurementsSidebarBody
              measurements={measurements}
              selectedFeatureId={selectedFeatureId}
              products={products ?? []}
              groupedAssignments={groupedAssignments}
              applyError={applyError}
              onSelectFeature={onSelectFeature}
              onUpdateProduct={onUpdateProduct}
              onToggleScreenshot={onToggleScreenshot}
            />
            <SidebarFooter
              persisting={persisting}
              canSave={canSave}
              isDirty={isDirty}
              applyLoading={applyLoading}
              productsLoading={productsLoading}
              onSave={onSave}
              onApply={onApply}
              hideApply={hideApply}
              onCreateProposal={onCreateProposal}
            />
          </MDBox>
        )}

        <SidebarToggleTab isOpen={isOpen} onToggle={onToggle} />
      </MDBox>
    </MDBox>
  );
}
